import useIsMobile from "@/hooks/useIsMobile";
import dynamic from "next/dynamic";

const SeriesPage = dynamic(() => import("@/screens/TestSeriesPage/SeriesPage"));
const PageLayout = dynamic(() => import("@/screens/Layout/PageLayout"));

export default function Category({
  categoryNewsListData = null,
  latestStoryData = null,
  latestVideoData = null,
  faqData = null,
  matchData = null,
}) {
  const isMobileDevice = useIsMobile();
  return (
    <>
      <PageLayout
        rightSideBarData={categoryNewsListData}
        latestStoryData={latestStoryData}
        latestVideoData={latestVideoData}
        isMobileDevice={isMobileDevice}
      >
        <SeriesPage
          categoryNewsListData={categoryNewsListData}
          isMobileDevice={isMobileDevice}
          faqData={faqData}
          matchData={matchData}
          currentTab={3}
        />
      </PageLayout>
    </>
  );
}

export const getServerSideProps = async (ctx) => {
  const { logger } = await import("@/utils/logging/log-util");
  try {
    const { getDataByUrl } = await import("@/handlers/commonApi");
    const { getLatestStoryVideoFeed, splitLatestStoryVideoFeed } = await import("@/handlers/content");
    // const { getFaqBySlug } = await import("@/handlers/faq");
    const { getRedisApiKey, fetchRedisWrapper } = await import(
      "@/handlers/redisKey"
    );
    const {
      getLiveMatches,
      getRecentMatches,
      getUpcomingMatches,
    } = await import("@/handlers/ipl");

    const { parseMatchData } = await import("@/utils/ipl");
    const { setPageTTL } = await import("@/utils/setPageTTL");
    const { getUnixTimeDaysAgo } = await import("@/utils/dateTimeFormat");
    const unixtime = getUnixTimeDaysAgo(15);
    //* get page from query param and subtract 1 from it , also error handle if not a number
    let page = ctx?.query?.page;
    if (isNaN(page)) {
      page = 0;
    }
    page = page ? parseInt(page) - 1 : 0;

    let categoryListRedisKey = getRedisApiKey({
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "getdatabyurl",
        url: "/sports",
        page: page,
        display: 6,
        type: "story",
      },
    });

    let faqRedisKey = getRedisApiKey({
      redisPrefix: "PREFIX_REDIS_ROS",
      params: { api: "staticpages", url: "ipl-2025-faqs" },
    });

    const latestStoryVideoRedisKey = getRedisApiKey({
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "latestcontentfeed",
        page: 0,
        display: 5,
        type: "story,video",
        unixtime,
      },
    });
    const getMatches = async () => {
      try {
        let matchArr = [];

        // Fetch all data in parallel to reduce load time
        const [liveMatchData, recentMatchData, upcomingMatchData] =
          await Promise.all([
            getLiveMatches(8159),
            getRecentMatches(8159),
            getUpcomingMatches(8159),
          ]);

        // Process Live Matches First (Max 6)
        if (liveMatchData.length) {
          matchArr = liveMatchData.map(parseMatchData);
        }
        // Add Recent Match If Needed
        if (recentMatchData?.data?.length) {
            for (let i = 0; i < recentMatchData.data.length; i++) {
              matchArr.push(parseMatchData(recentMatchData.data[i]));
            }
          
        }

        // Add Upcoming Matches Until 6
        if (upcomingMatchData?.data?.length) {
          const upcomingArr = upcomingMatchData?.data;
          for(let i=0; i<upcomingArr?.length; i++){
            const matchStats = parseMatchData(upcomingArr[i]);
            matchArr.push(matchStats);
          }
        }
        return matchArr;
      } catch (err) {
        logger.error(err);
      }
    };
    
    let [
      categoryNewsListData,
      { latestStoryData, latestVideoData },
      // faqData,
      matchData,
    ] = await Promise.all([
      fetchRedisWrapper(categoryListRedisKey, () =>
        getDataByUrl({
          url: "/sports",
          page: page,
          display: 6,
          type: "story",
        })
      ),
      fetchRedisWrapper(latestStoryVideoRedisKey, () =>
        getLatestStoryVideoFeed({
          page: 0,
          display: 5,
          unixtime,
        })
      ).then(splitLatestStoryVideoFeed),
      // fetchRedisWrapper(faqRedisKey, () =>
      //   getFaqBySlug({
      //     url: "ipl-2025-faqs",
      //   })
      // ),
      getMatches(),
    ]);

    setPageTTL(ctx, 120);
    return {
      props: {
        categoryNewsListData,
        latestStoryData,
        latestVideoData,
        faqData:null,
        matchData,
      },
    };
  } catch (error) {
    logger.error(error);
    return {
      notFound: true,
    };
  }
};
